import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaBus, FaMapMarkerAlt, FaUsers } from "react-icons/fa";
import { campuses } from "../data/campusesData";
import "./Campuses.css";

const Campuses = () => {
  return (
    <div className="campuses-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Our Campuses</h1>
            <p>
              Four world-class campuses across Bangalore serving 5000+ students
            </p>
          </motion.div>
        </div>
      </section>

      {/* Introduction */}
      <section className="intro-section section">
        <div className="container">
          <motion.div
            className="intro-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="section-title">Choose Your Nearest Campus</h2>
            <p>
              Sri Vani Education operates four strategically located campuses
              across Bangalore, each offering world-class facilities,
              experienced faculty, and a nurturing environment.
            </p>
          </motion.div>

          <div className="campus-stats">
            <div className="stat-item">
              <div className="stat-number">4</div>
              <div className="stat-label">Campuses</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5000+</div>
              <div className="stat-label">Students</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">300+</div>
              <div className="stat-label">Faculty</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15+</div>
              <div className="stat-label">Acres</div>
            </div>
          </div>
        </div>
      </section>

      {/* Campus Cards */}
      <section className="section bg-white">
        <div className="container">
          <div className="campus-overview-grid">
            {campuses.map((campus, index) => (
              <motion.div
                key={campus.id}
                className="campus-overview-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="campus-overview-image">
                  <img src={campus.image} alt={campus.name} />
                </div>
                <div className="campus-overview-body">
                  <h3>{campus.name}</h3>
                  <p className="campus-overview-tagline">{campus.tagline}</p>
                  <div className="campus-overview-meta">
                    <span>
                      <FaMapMarkerAlt />{" "}
                      {campus.contacts[0].addressLines.slice(-1)[0]}
                    </span>
                    <span>
                      <FaUsers /> {campus.students} students
                    </span>
                  </div>
                  <div
                    className="curricula-tags"
                    style={{ marginBottom: "1.2rem" }}
                  >
                    {campus.curricula.map((curr, idx) => (
                      <span key={idx} className="curriculum-tag">
                        {curr}
                      </span>
                    ))}
                  </div>
                  <Link
                    to={`/campuses/${campus.id}`}
                    className="btn btn-primary"
                  >
                    Explore Campus
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Transport Section */}
      <section className="transport-section section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="section-title">
              <FaBus style={{ marginRight: "1rem" }} />
              Transport Facilities
            </h2>
            <p className="section-subtitle">
              Safe and reliable school bus service covering all areas of
              Bangalore
            </p>
          </motion.div>
          <div className="grid grid-3">
            <div className="transport-card card">
              <h3>GPS Tracking</h3>
              <p>
                All buses equipped with real-time GPS tracking for parent
                monitoring
              </p>
            </div>
            <div className="transport-card card">
              <h3>Trained Attendants</h3>
              <p>
                Female attendants on every bus for student safety and assistance
              </p>
            </div>
            <div className="transport-card card">
              <h3>Wide Coverage</h3>
              <p>
                50+ routes covering entire Bangalore with convenient pick-up
                points
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          {/* <motion.div
            className="cta-content"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Visit Our Campuses</h2>
            <p>Schedule a campus tour and experience our world-class facilities firsthand</p>
            <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
          </motion.div> */}
        </div>
      </section>
    </div>
  );
};

export default Campuses;
